import React, { useEffect, useState } from 'react';
import api from '../services/api';
import Modal from '../components/Modal';
import Spinner from '../components/Spinner';
import { toast } from '../components/Toast';

const EMPTY_USER = { respProiect:'', macNr:'', email:'', adminu:'Level_0', inactiv:'', nrInmatriculareAsignat:'' };
const EMPTY_CERERE = { tipLimita:'useri', limitaCeruta:'', motiv:'' };

export default function Admin() {
  const [tab, setTab] = useState('users');
  const [users, setUsers] = useState([]);
  const [jurnal, setJurnal] = useState([]);
  const [limite, setLimite] = useState(null);
  const [istoricCereri, setIstoricCereri] = useState([]);
  const [vehicule, setVehicule] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState(EMPTY_USER);
  const [cerereForm, setCerereForm] = useState(EMPTY_CERERE);
  const [trimitand, setTrimitand] = useState(false);
  const [jurnalFiltre, setJurnalFiltre] = useState({ modul:'', utilizator:'', rezultat:'' });
  const isAdmin = localStorage.getItem('isAdmin') === 'true';

  useEffect(() => {
    if (tab==='users') loadUsers();
    else if (tab==='jurnal') loadJurnal();
    else if (tab==='limite') loadLimite();
  }, [tab]);

  // Lista de vehicule din flotă - folosită pentru combo-box-ul de asignare
  // atunci când rolul selectat este "Conducător auto".
  useEffect(() => {
    api.get('/api/auto/nruri').then(r => setVehicule(r.data)).catch(() => {});
  }, []);

  // Daca am fost navigati aici direct spre sub-tab-ul "Limită cont" (ex. din
  // Autovehicule, cand limita de vehicule e atinsa), deschidem direct acel sub-tab.
  useEffect(() => {
    if (sessionStorage.getItem('adminInitialTab') === 'limite') {
      sessionStorage.removeItem('adminInitialTab');
      setTab('limite');
    }
  }, []);

  const loadUsers = () => {
    setLoading(true);
    api.get('/api/admin/users').then(r=>setUsers(r.data)).finally(()=>setLoading(false));
  };

  const loadJurnal = (filtre = jurnalFiltre) => {
    setLoading(true);
    const params = new URLSearchParams();
    if (filtre.modul) params.set('modul', filtre.modul);
    if (filtre.utilizator) params.set('utilizator', filtre.utilizator);
    if (filtre.rezultat) params.set('rezultat', filtre.rezultat);
    api.get(`/api/admin/jurnal?${params.toString()}`).then(r=>setJurnal(r.data)).finally(()=>setLoading(false));
  };

  const loadLimite = () => {
    setLoading(true);
    api.get('/api/admin/limite').then(r=>setLimite(r.data)).finally(()=>setLoading(false));
    loadIstoricCereri();
  };

  const loadIstoricCereri = () => {
    api.get('/api/admin/cereri-limita-istoric').then(r=>setIstoricCereri(r.data)).catch(()=>setIstoricCereri([]));
  };

  const openAdd = async () => {
    // Verificăm limita ÎNAINTE de a deschide formularul - nu mai lăsăm utilizatorul
    // să completeze tot formularul doar ca să afle la final că a atins limita.
    try {
      const r = await api.get('/api/admin/limite');
      const { nrUseri, limitaUseri } = r.data;
      if (nrUseri >= limitaUseri) {
        const vreiSaContinui = window.confirm(
          `Ai atins limita de ${limitaUseri} utilizator(i) activi (${nrUseri}/${limitaUseri}).\n\n` +
          `Nu poți adăuga un utilizator nou fără să ceri creșterea limitei.\n\n` +
          `Vrei să treci la pagina „Limită cont" pentru a trimite o cerere de creștere?`
        );
        if (vreiSaContinui) setTab('limite');
        return;
      }
    } catch (e) {
      // Daca verificarea limitei a picat, nu blocam utilizatorul - formularul va
      // fi respins de backend la trimitere daca limita e totusi atinsa.
    }
    setForm(EMPTY_USER); setModal({mode:'add'});
  };
  const openEdit = (u) => { setForm({...u}); setModal({mode:'edit',id:u.respProiect}); };

  const save = async () => {
    if (form.adminu === 'conducator_auto' && !form.nrInmatriculareAsignat) {
      toast('Selectează vehiculul asignat conducătorului auto', 'error');
      return;
    }
    try {
      if (modal.mode==='add') await api.post('/api/admin/users', form);
      else await api.put(`/api/admin/users/${modal.id}`, form);
      setModal(null); loadUsers();
      toast(modal.mode==='add'?'Utilizator adăugat!':'Utilizator actualizat!');
    } catch(e) {
      const mesaj = e.response?.data?.error || e.message;
      toast('Eroare: ' + mesaj, 'error');
      if (e.response?.status === 403 && mesaj.includes('limita')) {
        setModal(null);
        setTab('limite');
      }
    }
  };

  const toggleActive = async (u) => {
    try {
      await api.put(`/api/admin/users/${u.respProiect}`, {...u, inactiv: u.inactiv==='da'?'':'da' });
      loadUsers(); toast('Status actualizat!');
    } catch(e) { toast('Eroare: '+(e.response?.data?.error||e.message),'error'); }
  };

  const trimiteCerere = async () => {
    if (!cerereForm.limitaCeruta || Number(cerereForm.limitaCeruta) < 1) {
      toast('Introdu o limită validă', 'error'); return;
    }
    setTrimitand(true);
    try {
      const r = await api.post('/api/admin/cerere-limita', cerereForm);
      toast(r.data.mesaj || 'Cerere trimisă!');
      setCerereForm(EMPTY_CERERE);
      loadIstoricCereri();
    } catch(e) {
      toast('Eroare: ' + (e.response?.data?.error || e.message), 'error');
    } finally {
      setTrimitand(false);
    }
  };

  const badgeStatus = (status) => {
    const stiluri = {
      pending:  { bg:'#fff3cd', color:'#856404', text:'În așteptare' },
      aprobat:  { bg:'#d4edda', color:'#155724', text:'Aprobat' },
      respins:  { bg:'#f8d7da', color:'#721c24', text:'Respins' },
    };
    const s = stiluri[status] || { bg:'#e2e3e5', color:'#383d41', text: status };
    return <span style={{background:s.bg,color:s.color,padding:'2px 8px',borderRadius:12,fontSize:11,fontWeight:'bold'}}>{s.text}</span>;
  };

  const f = (field, label, type='text', opts=null, required=false) => (
    <div className="form-group"><label>{label}{required && <span style={{color:'#e74c3c'}}> *</span>}</label>
      {opts
        ? <select value={form[field]||''} onChange={e=>setForm({...form,[field]:e.target.value})}>
            {opts.map(o=><option key={o.v} value={o.v}>{o.l}</option>)}
          </select>
        : <input type={type} value={form[field]||''} onChange={e=>setForm({...form,[field]:e.target.value})}/>
      }
    </div>
  );

  if (!isAdmin) return (
    <div style={{padding:40,textAlign:'center',color:'#c0392b',fontSize:14}}>
      ⛔ Acces interzis — doar administratorii pot accesa această pagină.
    </div>
  );

  return (
    <div>
      <div className="tabs">
        <button className={`tab-btn ${tab==='users'?'active':''}`} onClick={()=>setTab('users')}>👥 Utilizatori</button>
        <button className={`tab-btn ${tab==='limite'?'active':''}`} onClick={()=>setTab('limite')}>📊 Limite cont</button>
        <button className={`tab-btn ${tab==='jurnal'?'active':''}`} onClick={()=>setTab('jurnal')}>📋 Jurnal activitate</button>
      </div>

      {tab==='users' && (
        <>
          <div className="filter-bar">
            <button className="btn btn-success" onClick={openAdd}>+ Adaugă utilizator</button>
          </div>
          {loading ? <Spinner/> : (
            <table>
              <thead>
                <tr><th>Utilizator</th><th>Email</th><th>Rol</th><th>Vehicul asignat</th><th>Status</th><th>Acțiuni</th></tr>
              </thead>
              <tbody>
                {users.map(u=>(
                  <tr key={u.respProiect} style={{opacity: u.inactiv==='da'?0.5:1}}>
                    <td><b>{u.respProiect}</b></td>
                    <td style={{fontSize:12,color:'#666'}}>{u.email}</td>
                    <td>{u.adminu === 'conducator_auto' ? 'Conducător auto' : u.adminu}</td>
                    <td style={{fontSize:12}}>{u.nrInmatriculareAsignat || '—'}</td>
                    <td>
                      {u.inactiv==='da'
                        ? <span className="badge badge-danger">Inactiv</span>
                        : <span className="badge badge-ok">Activ</span>}
                    </td>
                    <td>
                      <button className="btn btn-warning btn-sm" onClick={()=>openEdit(u)}>✏️</button>{' '}
                      <button className="btn btn-sm btn-sm"
                        style={{background: u.inactiv==='da'?'#27ae60':'#e74c3c', color:'white'}}
                        onClick={()=>toggleActive(u)}>
                        {u.inactiv==='da'?'Activează':'Dezactivează'}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </>
      )}

      {tab==='limite' && (
        <>
          {loading || !limite ? <Spinner/> : (
            <div style={{padding:'10px 0'}}>
              <div className="form-row" style={{gap:20,marginBottom:24}}>
                <div className="card" style={{flex:1,padding:16}}>
                  <div style={{fontSize:12,color:'#888',marginBottom:4}}>Utilizatori</div>
                  <div style={{fontSize:22,fontWeight:'bold'}}>
                    {limite.nrUseri} / {limite.limitaUseri}
                  </div>
                  {limite.nrUseri >= limite.limitaUseri &&
                    <div style={{fontSize:12,color:'#c0392b',marginTop:4}}>Limită atinsă</div>}
                </div>
                <div className="card" style={{flex:1,padding:16}}>
                  <div style={{fontSize:12,color:'#888',marginBottom:4}}>Vehicule</div>
                  <div style={{fontSize:22,fontWeight:'bold'}}>
                    {limite.nrMasini} / {limite.limitaMasini}
                  </div>
                  {limite.nrMasini >= limite.limitaMasini &&
                    <div style={{fontSize:12,color:'#c0392b',marginTop:4}}>Limită atinsă</div>}
                </div>
              </div>

              <div className="card" style={{padding:16,maxWidth:480}}>
                <div style={{fontWeight:'bold',marginBottom:12}}>Cere creșterea unei limite</div>
                <div className="form-group">
                  <label>Tip limită</label>
                  <select value={cerereForm.tipLimita} onChange={e=>setCerereForm({...cerereForm,tipLimita:e.target.value})}>
                    <option value="useri">Utilizatori</option>
                    <option value="masini">Vehicule</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Limită nouă dorită<span style={{color:'#e74c3c'}}> *</span></label>
                  <input type="number" min="1" value={cerereForm.limitaCeruta}
                    onChange={e=>setCerereForm({...cerereForm,limitaCeruta:e.target.value})}/>
                </div>
                <div className="form-group">
                  <label>Motiv (opțional)</label>
                  <input type="text" value={cerereForm.motiv}
                    onChange={e=>setCerereForm({...cerereForm,motiv:e.target.value})}/>
                </div>
                <button className="btn btn-primary" disabled={trimitand} onClick={trimiteCerere}>
                  {trimitand ? 'Se trimite...' : 'Trimite cerere'}
                </button>
                <div style={{fontSize:11,color:'#888',marginTop:8}}>
                  Cererea va fi analizată de administrator. Vei putea adăuga mai mulți utilizatori/vehicule după aprobare.
                </div>
                <div style={{fontSize:11,color:'#888',marginTop:4}}>* Câmp obligatoriu</div>
              </div>

              <div className="card" style={{padding:16,marginTop:24}}>
                <div style={{fontWeight:'bold',marginBottom:12}}>Istoricul cererilor tale</div>
                {istoricCereri.length === 0 ? (
                  <div style={{fontSize:12,color:'#888'}}>Nu ai trimis încă nicio cerere.</div>
                ) : (
                  <table className="data-table">
                    <thead>
                      <tr>
                        <th>Tip limită</th><th>Limită cerută</th><th>Motiv</th>
                        <th>Status</th><th>Data cererii</th><th>Data răspunsului</th>
                      </tr>
                    </thead>
                    <tbody>
                      {istoricCereri.map(c => (
                        <tr key={c.id}>
                          <td>{c.tipLimita === 'useri' ? 'Utilizatori' : 'Vehicule'}</td>
                          <td>{c.limitaCeruta}</td>
                          <td>{c.motiv || '—'}</td>
                          <td>{badgeStatus(c.status)}</td>
                          <td>{c.dataCerere ? String(c.dataCerere).slice(0,16).replace('T',' ') : '—'}</td>
                          <td>{c.dataRaspuns ? String(c.dataRaspuns).slice(0,16).replace('T',' ') : '—'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            </div>
          )}
        </>
      )}

      {tab==='jurnal' && (
        <>
          <div style={{display:'flex',gap:8,alignItems:'center',flexWrap:'wrap',padding:'10px 14px',background:'#e8eef5',borderBottom:'1px solid #d0dcea'}}>
            <select value={jurnalFiltre.modul} onChange={e=>{const f={...jurnalFiltre,modul:e.target.value}; setJurnalFiltre(f); loadJurnal(f);}}
              style={{padding:'4px 8px',fontSize:12,border:'1px solid #ccc',borderRadius:3}}>
              <option value="">Toate modulele</option>
              <option value="Autentificare">Autentificare</option>
              <option value="Auto">Auto</option>
              <option value="Piese">Piese</option>
              <option value="Revizii">Revizii</option>
              <option value="Cheltuieli">Cheltuieli</option>
              <option value="Carburant">Carburant</option>
              <option value="Utilizatori">Utilizatori</option>
              <option value="Personal">Personal</option>
              <option value="FoaieParcurs">Foaie parcurs</option>
              <option value="CMR">CMR</option>
            </select>
            <select value={jurnalFiltre.rezultat} onChange={e=>{const f={...jurnalFiltre,rezultat:e.target.value}; setJurnalFiltre(f); loadJurnal(f);}}
              style={{padding:'4px 8px',fontSize:12,border:'1px solid #ccc',borderRadius:3}}>
              <option value="">Succes + Eroare</option>
              <option value="SUCCES">Doar succes</option>
              <option value="EROARE">Doar erori</option>
            </select>
            <input placeholder="Filtrează după utilizator..." value={jurnalFiltre.utilizator}
              onChange={e=>setJurnalFiltre({...jurnalFiltre,utilizator:e.target.value})}
              onKeyDown={e=>{if(e.key==='Enter') loadJurnal();}}
              style={{padding:'4px 8px',fontSize:12,border:'1px solid #ccc',borderRadius:3}}/>
            <button className="btn btn-sm" onClick={()=>loadJurnal()}>🔍 Caută</button>
            <span style={{fontSize:11,color:'#888',marginLeft:'auto'}}>Ultimele 500 înregistrări</span>
          </div>
          {loading ? <Spinner/> : (
            <div style={{overflowX:'auto'}}>
              <table>
                <thead>
                  <tr>
                    <th>Data</th><th>Ora</th><th>Utilizator</th><th>Operațiune</th>
                    <th>Modul</th><th>Detalii</th><th>IP</th><th>Rezultat</th>
                  </tr>
                </thead>
                <tbody>
                  {jurnal.map((j,i)=>(
                    <tr key={i} style={{background: j.rezultat==='EROARE' ? '#fdeeee' : 'transparent'}}>
                      <td style={{whiteSpace:'nowrap',fontSize:11}}>{j.data}</td>
                      <td style={{whiteSpace:'nowrap',fontSize:11}}>{j.ora}</td>
                      <td><b>{j.utilizator}</b></td>
                      <td>
                        <span className={`badge ${j.operatiune==='DELETE'||j.operatiune==='LOGIN_ESUAT'?'badge-danger':j.operatiune==='INSERT'||j.operatiune==='LOGIN'?'badge-ok':'badge-warning'}`}>
                          {j.operatiune}
                        </span>
                      </td>
                      <td style={{fontSize:11}}>{j.modul}</td>
                      <td style={{fontSize:11}}>{j.detalii}</td>
                      <td style={{fontSize:11,color:'#888'}}>{j.ipAdresa}</td>
                      <td style={{fontSize:11,color: j.rezultat==='EROARE'?'#c0392b':'#27ae60',fontWeight:'bold'}}>{j.rezultat}</td>
                    </tr>
                  ))}
                  {jurnal.length===0&&<tr><td colSpan={8} style={{textAlign:'center',padding:20,color:'#888'}}>Fără înregistrări</td></tr>}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}

      {modal && (
        <Modal title={modal.mode==='add'?'Adaugă utilizator':'Editează utilizator'} onClose={()=>setModal(null)} onSave={save}>
          <div className="form-row">{f('respProiect','Utilizator','text',null,true)}
            {f('macNr', modal?.mode==='edit' ? 'Parolă nouă (lasă gol pentru a păstra parola actuală)' : 'Parolă', 'text', null, modal?.mode!=='edit')}
          </div>
          <div className="form-row">{f('email','Email')}</div>
          <div className="form-row single">
            {f('adminu','Rol','text',[
              {v:'Level_0',l:'Standard (Level_0)'},
              {v:'admin',l:'Administrator'},
              {v:'conducator_auto',l:'Conducător auto'}
            ], true)}
          </div>
          {(form.adminu === 'conducator_auto' || form.adminu === 'admin') && (
            <div className="form-row single">
              <div className="form-group">
                <label>Vehicul asignat{form.adminu === 'conducator_auto' && <span style={{color:'#e74c3c'}}> *</span>}{form.adminu === 'admin' && ' (opțional)'}</label>
                <select value={form.nrInmatriculareAsignat||''}
                  onChange={e=>setForm({...form,nrInmatriculareAsignat:e.target.value})}>
                  <option value="">-- Selectează vehiculul --</option>
                  {vehicule.map(v=>
                    <option key={v.nrInmatriculare} value={v.nrInmatriculare}>{v.nrInmatriculare}</option>
                  )}
                </select>
                <div style={{fontSize:11,color:'#888',marginTop:4}}>
                  {form.adminu === 'conducator_auto'
                    ? 'Conducătorul auto va vedea și va putea adăuga date STRICT pentru acest vehicul.'
                    : 'Administratorul își păstrează toate drepturile; asignarea unui vehicul îl face să apară și în secțiunea Personal ca șofer (permise, amenzi etc.).'}
                </div>
              </div>
            </div>
          )}
          <div className="form-row single"><span style={{fontSize:11,color:'#888'}}>* Câmp obligatoriu</span></div>
        </Modal>
      )}
    </div>
  );
}
